export const categories = [
  { id: 911, name: "Shoes", nameIt: "Scarpe", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { id: 912, name: "Hoodies/Sweaters", nameIt: "Felpe/Maglioni", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { id: 913, name: "T-Shirts", nameIt: "T-Shirt", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { id: 914, name: "Jackets", nameIt: "Giacche", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { id: 915, name: "Pants/Shorts", nameIt: "Pantaloni/Corti", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { id: 916, name: "Headwear", nameIt: "Copricapo", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { id: 917, name: "Sets", nameIt: "Set", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { id: 918, name: "Underwear/Underpants", nameIt: "Intimo", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { id: 919, name: "Jersey", nameIt: "Maglie Sportive", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { id: 920, name: "Accessories", nameIt: "Accessori", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { id: 921, name: "Bags", nameIt: "Borse", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { id: 922, name: "Belts", nameIt: "Cinture", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { id: 923, name: "Perfumes", nameIt: "Profumi", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { id: 924, name: "Other Stuff", nameIt: "Altro", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

export const mainSiteUrl = "https://kaspreadsheet.com";

export const seoKeywords = [
  "itaobuy spreadsheet",
  "itaobuy sheet guida",
  "itaobuy spreadsheet italiano",
  "itaobuy spreadsheet recensione",
  "itaobuy sheet come funziona",
  "itaobuy spreadsheet sicurezza",
];

export const blogArticles = [
  {
    id: "guida-completa",
    title: "Itaobuy Spreadsheet: Guida Completa 2026",
    excerpt: "Scopri tutto quello che devi sapere su Itaobuy Spreadsheet: funzionalità, sicurezza, prezzi e confronti aggiornati per utenti italiani.",
    url: "/itaobuy-spreadsheet-guida",
    color: "from-amber-100/80 to-amber-50/60",
    textColor: "text-amber-900",
  },
  {
    id: "recensione",
    title: "Recensione Itaobuy Sheet: Opinioni Reali",
    excerpt: "Analisi indipendente e opinioni verificate degli utenti italiani su Itaobuy Spreadsheet. Pro, contro e valutazione completa.",
    url: "/itaobuy-spreadsheet-recensione",
    color: "from-emerald-100/80 to-emerald-50/60",
    textColor: "text-emerald-900",
  },
  {
    id: "sicurezza",
    title: "Itaobuy Spreadsheet è Sicuro? Guida alla Sicurezza",
    excerpt: "Tutto sulla sicurezza di Itaobuy Sheet: come proteggere i tuoi dati, evitare truffe e riconoscere piattaforme affidabili.",
    url: "/itaobuy-spreadsheet-sicurezza",
    color: "from-rose-100/80 to-rose-50/60",
    textColor: "text-rose-900",
  },
  {
    id: "confronto",
    title: "Itaobuy Spreadsheet vs Alternative: Confronto 2026",
    excerpt: "Confronto dettagliato tra Itaobuy Spreadsheet e le principali alternative. Funzionalità, prezzi e quale scegliere.",
    url: "/itaobuy-spreadsheet-confronto",
    color: "from-sky-100/80 to-sky-50/60",
    textColor: "text-sky-900",
  },
];

export const moreBlogArticles = [
  {
    id: "guida-acquisti",
    title: "Guida Acquisti Itaobuy Sheet: Come Comprare in Sicurezza",
    excerpt: "Tutto ciò che devi sapere prima di acquistare su Itaobuy Sheet: metodi di pagamento, spedizione, resi e consigli pratici per un acquisto senza rischi.",
    url: "/itaobuy-spreadsheet-guida-acquisti",
    color: "from-teal-100/80 to-teal-50/60",
    textColor: "text-teal-900",
    date: "12 Luglio 2026",
    readTime: "8 min",
  },
  {
    id: "principianti",
    title: "Itaobuy Spreadsheet per Principianti: Da Zero a Esperto",
    excerpt: "Una guida passo-passo pensata per chi non ha mai usato Itaobuy Sheet. Dalla registrazione alle funzionalità più utili, tutto spiegato in modo semplice.",
    url: "/itaobuy-spreadsheet-guida",
    color: "from-indigo-100/80 to-indigo-50/60",
    textColor: "text-indigo-900",
    date: "10 Luglio 2026",
    readTime: "15 min",
  },
  {
    id: "trucchi",
    title: "10 Trucchi Itaobuy Spreadsheet che Devi Conoscere",
    excerpt: "Funzionalità nascoste e consigli avanzati per usare Itaobuy Sheet come un vero professionista. Aumenta la tua produttività con questi suggerimenti esclusivi.",
    url: "/itaobuy-spreadsheet-guida",
    color: "from-orange-100/80 to-orange-50/60",
    textColor: "text-orange-900",
    date: "08 Luglio 2026",
    readTime: "10 min",
  },
  {
    id: "automazione",
    title: "Automazione con Itaobuy Spreadsheet: Risparmia Ore di Lavoro",
    excerpt: "Scopri come automatizzare attività ripetitive con Itaobuy Sheet. Dalle formule avanzate alle macro, tutto per lavorare meno e ottenere di più.",
    url: "/itaobuy-spreadsheet-confronto",
    color: "from-purple-100/80 to-purple-50/60",
    textColor: "text-purple-900",
    date: "06 Luglio 2026",
    readTime: "12 min",
  },
  {
    id: "alternative",
    title: "Migliori Alternative a Itaobuy Spreadsheet nel 2026",
    excerpt: "Confronto approfondito tra Itaobuy Sheet e i principali concorrenti. Analizziamo prezzo, funzionalità e facilità d'uso per ogni alternativa.",
    url: "/itaobuy-spreadsheet-confronto",
    color: "from-lime-100/80 to-lime-50/60",
    textColor: "text-lime-900",
    date: "04 Luglio 2026",
    readTime: "14 min",
  },
  {
    id: "ecommerce",
    title: "Itaobuy Sheet per E-commerce: Gestione Completa",
    excerpt: "Come usare Itaobuy Spreadsheet per gestire il tuo negozio online: inventario, ordini, clienti e analisi vendite tutto in un unico strumento.",
    url: "/itaobuy-spreadsheet-recensione",
    color: "from-red-100/80 to-red-50/60",
    textColor: "text-red-900",
    date: "02 Luglio 2026",
    readTime: "11 min",
  },
  {
    id: "errori",
    title: "Errori Comuni con Itaobuy Spreadsheet e Come Evitarli",
    excerpt: "I 7 errori più frequenti che gli utenti commettono con Itaobuy Sheet e le soluzioni pratiche per evitarli. Non cadere in queste trappole.",
    url: "/itaobuy-spreadsheet-sicurezza",
    color: "from-stone-100/80 to-stone-50/60",
    textColor: "text-stone-900",
    date: "30 Giugno 2026",
    readTime: "9 min",
  },
  {
    id: "dashboard",
    title: "Creare Dashboard Professionali con Itaobuy Spreadsheet",
    excerpt: "Guida visiva per creare dashboard interattive usando Itaobuy Sheet. Grafici dinamici, KPI e report automatici per impressionare il tuo team.",
    url: "/itaobuy-spreadsheet-confronto",
    color: "from-cyan-100/80 to-cyan-50/60",
    textColor: "text-cyan-900",
    date: "28 Giugno 2026",
    readTime: "13 min",
  },
  {
    id: "team",
    title: "Collaborazione in Team con Itaobuy Spreadsheet",
    excerpt: "Come usare Itaobuy Sheet per lavorare in gruppo: condivisione, commenti, controllo versioni e best practice per la collaborazione efficace.",
    url: "/itaobuy-spreadsheet-recensione",
    color: "from-fuchsia-100/80 to-fuchsia-50/60",
    textColor: "text-fuchsia-900",
    date: "26 Giugno 2026",
    readTime: "10 min",
  },
];

export const testimonials = [
  {
    name: "Marco R.",
    role: "Utente Verificato",
    avatar: "MR",
    rating: 5,
    text: "Itaobuy Spreadsheet ha completamente trasformato il modo in cui gestisco i miei dati. L'interfaccia è intuitiva e le funzionalità di automazione mi fanno risparmiare ore ogni settimana. Lo consiglio a tutti i professionisti italiani.",
    title: "Eccellente per la produttività",
  },
  {
    name: "Elena B.",
    role: "Freelance Designer",
    avatar: "EB",
    rating: 5,
    text: "Utilizzo Itaobuy Sheet da oltre un anno e non potrei farne a meno. La possibilità di organizzare i progetti e collaborare in tempo reale è fantastica. Finalmente uno strumento pensato per chi lavora in modo creativo.",
    title: "Perfetto per freelance",
  },
  {
    name: "Luca D.",
    role: "Small Business Owner",
    avatar: "LD",
    rating: 4,
    text: "Abbiamo integrato Itaobuy Spreadsheet nella nostra attività e i risultati sono stati immediati. Gestione inventario, ordini e analisi tutto in un unico posto. Un ottimo strumento per le piccole imprese italiane.",
    title: "Ideale per piccole imprese",
  },
  {
    name: "Sofia M.",
    role: "Marketing Specialist",
    avatar: "SM",
    rating: 5,
    text: "La parte migliore di Itaobuy Sheet è la flessibilità. Posso creare dashboard personalizzate per ogni campagna marketing e tenere traccia di tutte le metriche importanti senza dover saltare tra diversi strumenti.",
    title: "Flessibilità incredibile",
  },
  {
    name: "Andrea P.",
    role: "Data Analyst",
    avatar: "AP",
    rating: 5,
    text: "Come analista di dati, ho provato decine di spreadsheet tool. Itaobuy Spreadsheet si distingue per la combinazione di potenza e facilità d'uso. Le funzioni avanzate sono accessibili anche ai principianti.",
    title: "Potente ma accessibile",
  },
  {
    name: "Giulia F.",
    role: "E-commerce Manager",
    avatar: "GF",
    rating: 4,
    text: "Gestire un e-commerce con Itaobuy Sheet è diventato molto più semplice. Tabelle dinamiche, filtri avanzati e sincronizzazione dati rendono la gestione quotidiana estremamente efficiente.",
    title: "Ottimo per e-commerce",
  },
];